import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { Database } from '../../server/database';
import { Server } from '../../server/server';
import './GameCard.css'

interface GameCardProps {
  id: string;
  link: string;
}

interface GameCardState {
  link: string;
}

class GameCard extends React.Component<GameCardProps, GameCardState> {

  constructor(props: GameCardProps) {
    super(props);
    this.state = {
      link: ''
    };
  }

  onClick() {
    if(this.props.link == 'game' && !Server.account.isLoggedIn())
      return;

    this.setState({link: this.props.link});
  }

  render() {
    if(this.state.link == 'play')
      return (<Navigate to={'/game/' + this.props.id} />);

    if(this.state.link == 'game')
      return (<Navigate to={'/' + this.props.id} />);

    let data = Database.getGame(this.props.id);

    return (
      <div className="game-card">
        <div className="game-card-header">{data.name}</div>
        <div className="game-card-contents">
          <img className="game-card-image" src={'/' + data.image} alt='' onClick={() => this.onClick()}></img>
        </div>
        <div className="game-card-data">
          <div className="game-card-data-description">{data.description}</div>
        </div>
      </div>
    );
  }
}

export default GameCard;
